import {Injectable} from 'ng-metadata/core';

 export const TOO_MANY_CLAUSES = 'search.error.wildcards.toomanyclauses';
 export const NOT_ALL_SLICES_SEARCHED = 'search.error.ui.slice.down';
 export const ERR_BLENDED_TIMEOUT = 'search.error.search.blendedsearch';
 export const RESULTS_NOTE_EXPANDED_SEARCH_FMT_CODE = 'results.note.expanded_search';
 export const ILLEGAL_SEARCH_TERM = 'search.error.illegal.search.term';
 export const QUERY_CROSS_SYSTEM_LIMITS = 'search.error.query.cross.system.limits';
 export const QUERY_TOO_MANY_BOOLEAN = 'search.error.query.too.many.boolean';
 export const SERVER_ERROR = 'search.error.ui.server.error';


@Injectable()
export class SearchErrorMessageService {

    get tooManyClauses(){
       return TOO_MANY_CLAUSES;
    }

    get notAllSlicesSearched(){
       return NOT_ALL_SLICES_SEARCHED;
    }

    get blendedTimeout(){
       return ERR_BLENDED_TIMEOUT;
    }

    get expansionUiNotice(){
       return RESULTS_NOTE_EXPANDED_SEARCH_FMT_CODE;
    }

    get illegalSearchTerm(){
       return ILLEGAL_SEARCH_TERM;
    }

    get crossSystemLimits(){
       return QUERY_CROSS_SYSTEM_LIMITS;
    }

    get tooManyBoolean(){
       return QUERY_TOO_MANY_BOOLEAN;
    }

    get serverError(){
       return SERVER_ERROR;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/errorMessage/searchErrorMessage.service.ts